/* eslint-disable @typescript-eslint/no-unused-vars */
import { RefObject, useContext } from "react";
import {
	IShopLoyaltyOffer,
	IShopSection
} from "contexts/WebStoreProvider/types";
import getSectionIcon from "utils/svgIcons";
import Section from "components/Section";
import LoyaltyOfferCard from "../LoyaltyOfferCard";
import LoyaltyOfferCardV2 from "../LoyaltyOfferCardV2";
import { Container } from "@mui/material";
import { LoyaltyContext } from "pages/LoyaltyShop";
import { ISectionMenuItem } from "components/PageTopNav";
import { SectionMenu } from "components/PageTopNavV2/lib/SectionMenu";
import {
	SectionMenuContainer,
	sectionMenuContainerSxProps,
	sectionMenuInnerSxProps
} from "components/PageTopNavV2/styled";
import useBreakpoints from "hooks/useBreakpoints";
import { FeaturesFlags } from "helpers/flagsConfig";
import { useEnvContext } from "contexts";
import { useAppDispatch } from "hooks";
import { onOpenPopUp } from "redux/slices";

const LoyaltyOfferSection = ({
	data,
	sectionRef,
	sectionOffers
}: {
	className?: string;
	data: IShopSection;
	sectionRef: RefObject<HTMLElement>;
	sectionOffers: IShopLoyaltyOffer[];
}): JSX.Element => {
	const backgroundImageUrl = data?.cardBackgroundImageUrl || "";
	const dispatch = useAppDispatch();
	const { isSmDown } = useBreakpoints();
	const { sectionMenuData }: { sectionMenuData: ISectionMenuItem[] } =
		useContext(LoyaltyContext);
	const { isFeatureFlagEnabled } = useEnvContext();

	const singleItemsOffersFiltered = sectionOffers.filter(
		(offer) =>
			!(
				offer.sectionName === "daily_deals" &&
				isFeatureFlagEnabled(FeaturesFlags.LOYALTY_SHOP_CAROUSEL)
			)
	);

	const singleItemsOffers: JSX.Element[] = singleItemsOffersFiltered.map(
		(o, i) => {
			return (
				<LoyaltyOfferCard
					data={o}
					backgroundImageUrl={backgroundImageUrl}
					key={o.rewardId + i}
				/>
			);
		}
	);

	const dailyDealsFiltered = sectionOffers.filter(
		(offer) =>
			offer.sectionName === "daily_deals" &&
			isFeatureFlagEnabled(FeaturesFlags.LOYALTY_SHOP_CAROUSEL)
	);

	const dailyDeals: JSX.Element[] = dailyDealsFiltered.map((o, i) => {
		return (
			<LoyaltyOfferCardV2
				data={o}
				backgroundImageUrl={backgroundImageUrl}
				key={o.rewardId + i}
			/>
		);
	});

	const dailySectionProps = {
		offers: dailyDeals,
		sectionRef,
		headerText: data.title,
		iconUrl: getSectionIcon(data.name)?.url,
		icon: getSectionIcon(data.name)?.svg,
		display: "DailyDealsCarousel",
		isHideShowLess: true,
		sectionPage: "loyalty",
		handleInfoButtonClick: () => {
			dispatch(onOpenPopUp("tutorial-loyalty-shop"));
		}
	};

	const sectionProps = {
		offers: singleItemsOffers,
		sectionRef,
		headerText: data.title,
		iconUrl: getSectionIcon(data.name)?.url,
		icon: getSectionIcon(data.name)?.svg,
		display: "grid",
		isHideShowLess: true,
		sectionPage: "loyalty"
	};

	return (
		<>
			<Section {...dailySectionProps} />
			{dailyDealsFiltered.length > 0 && (
				<SectionMenuContainer
					id="sub-menu"
					className="section-menu-container"
					sx={{
						...sectionMenuContainerSxProps,
						width: "100%",
						top: isSmDown ? "55px" : "65px",
						position: "sticky",
						marginTop: "16px"
					}}
				>
					<Container
						className="section-menu-inner"
						sx={{ ...sectionMenuInnerSxProps }}
					>
						<SectionMenu items={sectionMenuData} />
					</Container>
				</SectionMenuContainer>
			)}
			<Section {...sectionProps} />
		</>
	);
};

export default LoyaltyOfferSection;
